import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

function LoadingIcon(props) {
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 100,
      }}
      spin
    />
  );
  return <Spin indicator={antIcon} />;
}
export default LoadingIcon;
